import {copilot} from '@cl/shared';
import accountAnalyticsContext from 'common/src/modules/analytics/copilot/agents/accountAnalyticsAgent/contexts/accountAnalyticsContext';
import campaignAnalyticsContext from 'common/src/modules/analytics/copilot/agents/campaignAnalyticsAgent/contexts/campaignAnalyticsContext';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {CLStore} from 'common/src/redux/store';

function initializeAnalyticsUiContexts(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.Dashboard, {
    description:
      'The account analytics dashboard shows account-wide performance metrics, dashboards, and cross-campaign insights.',
    contexts: [accountAnalyticsContext(store)],
  });

  copilot.uiContexts.registerUiContexts(BreadcrumbName.CampaignInsights, {
    description:
      'The campaign insights page shows analytics dashboards, metrics, and performance data for the campaign.',
    contexts: [campaignAnalyticsContext(store)],
  });
}

export default initializeAnalyticsUiContexts;
